import { Observable } from "rxjs";
import { StateService } from "./stateService";

export interface MandantBereichState {
    searchMethod: string
    filterItem?: [{
    mandantId?: number
    bereichId?: number
    }]
  }



const initialState: MandantBereichState = {
    searchMethod: "Bereich"
}

export class MandantBereichServiceForRoot extends StateService<MandantBereichState>{
    public static service: MandantBereichServiceForRoot;    

    public static getMandantBereichStateService() : MandantBereichServiceForRoot {
        if ( this.service === undefined) {
            this.service = new MandantBereichServiceForRoot();
        }
        return this.service;
    }

    private constructor() {
        super(initialState);        
    }
    
    public subscription(): Observable<MandantBereichState> {
        return this.subscribe();
    }

    public reset() {
        
        this.changeState(initialState)
    }

    public changeMandant(mandantBereichState: MandantBereichState) : void {
        
        this.changeState(mandantBereichState);
    }

    public get mandantBereichState(): MandantBereichState {
        return this.state;
    }

    public get bereiche() : string {
        if ( this.state === undefined || this.state.filterItem === undefined) return "0"
        let result = ""
        let div = ""       
        this.state?.filterItem.forEach( (row) => {
            if ( row.bereichId !== undefined) {
                result = result + div + row.bereichId.toString();
                div=","
            }
        });
        if ( result == "") return "0"
        return result;        
    }
}